<template>
  <ReviewsBlock v-bind="props" />
</template>

<script setup lang="ts">
import type { ReviewsBlock as ReviewsBlockProps } from '../ReviewsBlock/ReviewsBlock.vue'
// eslint-disable-next-line no-duplicate-imports
import ReviewsBlock from '../ReviewsBlock/ReviewsBlock.vue'
// eslint-disable-next-line no-duplicate-imports

const props = defineProps<ReviewsBlockProps>()
</script>

<style scoped></style>
